module.exports = __webpack_public_path__ + "img/eye.4c8ef593.svg";